import { OnboardingProfileAttributes } from "@/src/sb/components/Analytics/AnalyticsService"

import { ProfileCompletionData } from "./ProfileCompletionWizard"
import { ProfileSetupData } from "./ProfileSetupWizard"
import {
  buildProfileCompletionPayload,
  buildProfilePayload
} from "./profilePayload"

export const buildOnboardingAttributes = (
  data: ProfileSetupData,
  includeOrganisation: boolean
): OnboardingProfileAttributes => {
  const payload = buildProfilePayload(data, includeOrganisation)

  return {
    job_title: payload.jobTitle,
    team: payload.team,
    phone_number: payload.phoneNumber,
    city: payload.city,
    country: payload.country,
    company_name: payload.companyName,
    industry: payload.industry,
    company_size: payload.companySize,
    referral_source: payload.referralSource,
    use_cases: payload.useCases,
    data_platforms: payload.dataPlatforms
  }
}

export const buildProfileCompletionAttributes = (
  data: ProfileCompletionData
): OnboardingProfileAttributes => {
  const payload = buildProfileCompletionPayload(data)

  return {
    team: payload.team,
    use_cases: payload.useCases
  }
}
